















































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import {
  ROUTE_HOME,
  ROUTE_ALPACAS,
  ROUTE_ADOPT,
  ROUTE_SCARFS,
  ROUTE_BREEDING,
  ROUTE_FARM,
  ROUTE_RECYCLE,
  ROUTE_BANK,
} from '@/router';
import { loadWeb3 } from '@/utils/web3';
import NavbarTab from '@/components/NavbarTab.vue';
import DMenu from '@/components/DMenu.vue';
import DMenuItem from '@/components/DMenuItem.vue';
import { validateAccount, balanceOf } from '@/utils/web3';
import { addressFormat } from '@/utils/unit';
import { walletConnectInit } from '@/utils/walletConnect';
import { languageList } from '@/i18n';

@Component({
  components: {
    NavbarTab,
  },
})
export default class TopNavbar extends Vue {
  public guideHover: boolean = false;
  public alpaBalance: string = '0';
  public navAlpacasList = [
    ROUTE_ALPACAS,
    ROUTE_ADOPT,
    ROUTE_BREEDING,
  ];

  public navbarETHList = [
    ROUTE_HOME,
    ROUTE_ALPACAS,
    ROUTE_ADOPT,
    ROUTE_BREEDING,
    ROUTE_FARM,
    ROUTE_RECYCLE,
    ROUTE_SCARFS,
  ];

  public navbarBSCList = [
    ROUTE_HOME,
    ROUTE_ALPACAS,
    ROUTE_ADOPT,
    ROUTE_BREEDING,
    ROUTE_FARM,
    ROUTE_RECYCLE,
    ROUTE_SCARFS,
    ROUTE_BANK,
  ];

  public netList = ['Ethereum', 'Binance'];

  get navbarList() {
    return this.isBSC ? this.navbarBSCList : this.navbarETHList;
  }

  get account() {
    return this.$store.getters.getAccount;
  }

  get accountFormat() {
    if (this.account) {
      return addressFormat(this.account);
    }
    return null;
  }

  get ROUTE_HOME() {
    return ROUTE_HOME;
  }

  get ROUTE_ALPACAS() {
    return ROUTE_ALPACAS;
  }

  get ROUTE_ADOPT() {
    return ROUTE_ADOPT;
  }

  get ROUTE_BREEDING() {
    return ROUTE_BREEDING;
  }

  get ROUTE_FARM() {
    return ROUTE_FARM;
  }

  get ROUTE_RECYCLE() {
    return ROUTE_RECYCLE;
  }

  get ROUTE_SCARFS() {
    return ROUTE_SCARFS;
  }

  get ROUTE_BANK() {
    return ROUTE_BANK;
  }

  get localLang(): 'en' | 'cn' {
    return this.$store.getters.lang;
  }

  get localLangText() {
    return languageList[this.localLang] || 'EngLish';
  }

  get localLangList() {
    return languageList;
  }

  get curNet() {
    return process.env.VUE_APP_BSC ? 'Binance' : 'Ethereum';
  }

  get isBSC() {
    return !!process.env.VUE_APP_BSC;
  }

  get chainID() {
    return this.$store.getters.chainID;
  }

  get isCorrectNet() {
    return Number(this.chainID) === Number(process.env.VUE_APP_CHAIN_ID)
    || Number(this.chainID) === parseInt(process.env.VUE_APP_CHAIN_ID!, 16);
  }

  public async handleConnectWallet() {
    // await loadWeb3();
    // walletConnectInit(this);
    await validateAccount(this);
  }

  public isCurrentPage(name: string | string[]) {
    if (typeof name === 'object') {
      return name.indexOf(this.$route.name!) !== -1;
    }
    return this.$route.name!.indexOf(name) !== -1;
  }

  public navName(nav: string) {
    if (nav === ROUTE_RECYCLE) {
      return 'WOOL';
    }
    if (nav === ROUTE_SCARFS) {
      return 'Accessories';
    }
    if (nav === ROUTE_ALPACAS) {
      return 'MyAlpacas';
    }
    return nav;
  }

  public goGuide() {
    window.open('https://guide.alpaca.city/', '_blank');
  }

  public async getAlpaBalance() {
    const amount = await balanceOf(this.account);
    if (amount) {
      this.alpaBalance = amount;
    }
  }

  public chooseLang(lang: string) {
    this.$store.dispatch('loadLanguage', {lang, context: this});
  }

  public openSidebar() {
    this.$store.commit('setReferSidebar', true);
  }

  public chooseNet(net: string) {
    if (net === this.curNet) {
      return;
    }
    if (net === 'Ethereum') {
      window.open(process.env.VUE_APP_ETH_WEB, '_blank');
    } else {
      window.open(process.env.VUE_APP_BSC_WEB, '_blank');
    }
  }

  @Watch('account', {immediate: true})
  public onAccount(val: string) {
    if (val) {
      this.getAlpaBalance();
    }
  }
}
